import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {LocationService} from "../../service/location.service";
import {Place} from "../../model/place.model";
import {NgIf} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'app-distance-place-footer',
  templateUrl: './distance-place-footer.component.html',
  styleUrls: ['./distance-place-footer.component.scss'],
  imports: [
    NgIf,
    TranslateModule
  ],
  standalone: true
})
export class DistancePlaceFooterComponent implements OnInit, OnChanges {

  @Input() distance: number;
  @Input() distanceLabel: string;

  private CONFIG = {
    walkingSpeedMps: 1.39,
    walkingThresholdMinutes: 15,
    averageCarSpeedKmh: 30
  };

  minutes: number;
  directionType: 'car' | 'walk';

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getEstimatedTravelLabel(+changes['distance']?.currentValue);
  }

  ngOnInit() {
  }

  getEstimatedTravelLabel(distanceInMeters: number) {
    const maxWalkingDistance = this.CONFIG.walkingSpeedMps * 60 * this.CONFIG.walkingThresholdMinutes; // ≈ 1170 metri
    const isWalkAvailable = distanceInMeters <= maxWalkingDistance;
    const averageCarSpeedKmh = this.CONFIG.averageCarSpeedKmh; // media urbana
    const timeInHours = distanceInMeters / 1000 / averageCarSpeedKmh;

    this.directionType = isWalkAvailable ? 'walk': 'car';
    this.minutes = isWalkAvailable ? Math.round(distanceInMeters / (this.CONFIG.walkingSpeedMps * 60)): Math.round(timeInHours * 60);
  }

}
